import { styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import Typography from "@mui/material/Typography";

export const TextButtonLikeDarkGrey = styled(Typography)(({ theme }) => ({
  color: grey["800"],
  fontWeight: "bold",
  boxShadow: "none",
  borderRadius: 14,
  padding: "6px",
  backgroundColor: grey[200] + " !important",
  "&:hover": {
    boxShadow: "none",
    backgroundColor: grey[100] + " !important",
  },
}));

export const TextButtonLike = styled(Typography)(
  ({ backgroundColor, color }) => ({
    color: color || grey["800"],
    fontWeight: "bold",
    boxShadow: "none",
    borderRadius: 14,
    padding: "6px",
    backgroundColor: (backgroundColor || grey[200]) + " !important",
  })
);
